module.exports = __webpack_public_path__ + "static/media/ft1-cat.b8ec4332.png";